import React from 'react'
import Image from 'gatsby-image'
import { Link } from 'gatsby'
import { DocumentOutlineSection, H } from 'react-document-section'

import {
  articlePreview,
  image as imageStyle,
  imagePlaceholder,
  content,
  contentRatioContainer,
  contentOverflowContainer,
  categoryLink,
  title as titleStyle,
  excerpt as excerptStyle,
} from './card.module.scss'

export interface ArticlePreviewCardProps {
  title: string
  path: string
  category: {
    displayName: string
    fields: { path: string }
  }
  excerpt: string
  image: EF.FluidImageNode
}

const ArticlePreviewCard = ({
  title,
  path,
  category,
  excerpt,
  image,
}: ArticlePreviewCardProps) => (
  <DocumentOutlineSection title={title}>
    <div className={articlePreview}>
      <div className={imageStyle}>
        <Link to={path}>
          {image ? (
            <Image
              alt={image.fields.asset.title}
              fluid={{
                ...image.fields.asset.fluid,
                sizes:
                  '(min-width: 1200px) 272px, (min-width: 992px) calc(33.3vw - 50px), (min-width: 768px) calc(50vw - 62px), (min-width: 598px) calc(45vw - 27px), calc(100vw - 60px)',
              }}
            />
          ) : (
            <div className={imagePlaceholder} />
          )}
        </Link>
      </div>
      <div className={content}>
        <div className={contentRatioContainer}>
          <div className={contentOverflowContainer}>
            <Link to={category.fields.path} className={categoryLink}>
              {category.displayName}
            </Link>
            <Link to={path}>
              <H className={titleStyle} />
              <p className={excerptStyle}>{excerpt}</p>
            </Link>
          </div>
        </div>
      </div>
    </div>
  </DocumentOutlineSection>
)

export default ArticlePreviewCard
